import styled from "@emotion/styled/macro";
import { colors, views } from "../../../../common/styles/theme.styles";

export const SectionWrapper = styled.div`
    display:flex;
    // padding:24px 240px 16px 240px;
    // padding:24px 16px;
    /* padding:${props => props.padding ? props.padding : '24px'}; */
    padding: 24px 0;
    flex-direction:column;
    width:100%;
    /* max-width: ${props => props.fullWidth ? '100%' : '512px'}; */
    /* margin: 0 auto; */
    width: 100%;
    // background-color:${props => props.index % 2 === 1 ? '#fbfcfc' : '#fff'};
    /* ${props => props.horizntalSections ? `
        flex-direction:row;
        &:not(:last-child){
            border-bottom: 1px solid #E5E5E5;
        }
    ` : `
        flex-direction:column;
    `} */
        
    ${views.tablet}{
        ${props => props.withTopBorder ? `border-top: 1px solid ${colors.gray3};` : ``}
    }

`;
